import { Button, Paper, Stack, Typography } from '@mui/material';
import { useForm, FormProvider } from 'react-hook-form';
import { TextField } from '../../components';
import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import axios from 'axios';
import { BASE_URL } from '../../utils';
import { toast } from '../../utils';

export const Activation = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [macAddress, setMacAddress] = useState(null);
  const [otpSent, setOtpSent] = useState(false);

  const methods = useForm();

  useEffect(() => {
    const fetchMacAddress = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${BASE_URL}/mac-address`);
        setMacAddress(response.data.macAddress);
        methods.setValue("mac_address", response.data.macAddress);
      } catch (error) {
        console.error('Error fetching MAC address:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchMacAddress();
  }, [methods]);

  // Request OTP with MAC Address
  const requestOTP = async () => {
    const email = methods.getValues("email");
    if (!email) {
      toast('Please enter your email first!', { variant: 'error' });
      return;
    }
    
    try {
      setLoading(true);
      const response = await axios.post(`https://hms-admin-panel.vercel.app/api/getotp`, { email, macAddress });
      
      if (response.data.success) {
        setOtpSent(true);
        toast('OTP sent to your email!', { variant: 'success' });
      } else {
        toast(response.data.message || 'Failed to send OTP!', { variant: 'error' });
      }
    } catch (error) {
      toast('Error sending OTP!', { variant: 'error' });
    } finally {
      setLoading(false);
    }
  };

  // Form submission handler
  const handleSubmit = async (formValues) => {
    setLoading(true);
    try {
      const activationResponse = await axios.post(`https://hms-admin-panel.vercel.app/api/activation`, formValues);

      if (activationResponse.data.success) {
        const userData = activationResponse.data.data; // Get user data from activation response

        // Send the user data to store in MongoDB
        const storeResponse = await axios.post(`${BASE_URL}/adminUsers`, { data: userData });

        if (storeResponse.data.success) {
          toast('Admin user created successfully!', { variant: 'success' });
          navigate('/'); // Redirect after successful activation
        } else {
          toast(storeResponse.data.message || 'Creation failed!', { variant: 'error' });
        }
      } else {
        toast(activationResponse.data.message || 'Activation failed!', { variant: 'error' });
      }
    } catch (error) {
      toast('Something went wrong!', { variant: 'error' });
    } finally {
      setLoading(false);
    }
  };



  return (
    <Paper
      sx={{
        width: 'clamp(30rem, 50%, 40rem)',
        mx: 'auto',
        my: 7,
        p: 3,
        backgroundColor: 'transparent',
        backdropFilter: 'blur(5rem)',
        borderRadius: '1.5rem',
        height: otpSent ? '38rem' : '28rem'
      }}
    >
      <Typography variant="h3" gutterBottom color="common.white" textAlign="center">
        Activation
      </Typography>
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(handleSubmit)}>
          <Stack spacing={2}>
            <TextField name="email" placeholder="Email" />
            
            {/* Request OTP Button */}
            {!otpSent && (
              <Button 
                disabled={loading} 
                fullWidth 
                variant="outlined" 
                color="secondary" 
                onClick={requestOTP}
              >
                Get OTP
              </Button>
            )}

            {/* Show OTP & Password fields only after OTP is sent */}
            {otpSent && (
              <>
                <TextField name="otp" placeholder="Enter OTP" type="text" />
                <TextField name="password" placeholder="Enter Password" type="password" />
                <input type="hidden" {...methods.register("mac_address")} value={macAddress || ''} />

                {/* Activate Button */}
                <Button 
                  disabled={loading} 
                  fullWidth 
                  sx={{ mt: 3 }} 
                  variant="contained" 
                  color="primary" 
                  type="submit"
                >
                  Activate
                </Button>
              </>
            )}
          </Stack>
        </form>
      </FormProvider>
    </Paper>
  );
};
